import Store from '../store/index'
import axios from 'axios'
import usuarioHelper from '@/helpers/usuario-logado.js';
import store from '../store/index';

export default {
  processarMudancaTela: async function (to, from, next) {
    if (to.params.login) { //Dá refresh na página na ação de login.
      location.reload();
    }
    else {
      var usuariologado = usuarioHelper.USUARIO_LOGADO();
      document.title = `Apisul Seguros - ${to.meta.title}`;
      Store.commit('endLoading');
      let acessoNegado = false;

      if (to.meta.requiresAuth) {
        if (!usuariologado || !usuariologado.idUsuario) {
          next({ name: 'Login' });
        } else {
           await axios.get(`${process.env.URL_USUARIOMS}/v1/no-auth/atualizaToken?token=${localStorage.getItem('token')}`)
          .then((response) => {
            if (!response.data) {
              localStorage.removeItem('token');
              next({ name: 'Login' });
            } else {
              localStorage.setItem('token', response.data);
              usuariologado = usuarioHelper.USUARIO_LOGADO();
              store.commit('permissoes/setPermissoes', usuarioHelper.USUARIO_LOGADO().perfil.permissoes);
              const listaPermissoes = usuariologado.perfil.permissoes;
              const acesso = listaPermissoes.filter(permissao => permissao.id == to.meta.permissao);

              if (acesso.length == 0) {
                acessoNegado = true;
                next({ name: 'AcessoNegado' });
              } else if (to.meta.flagUsuario && !usuariologado[to.meta.flagUsuario]) {
                acessoNegado = true;
                next({ name: 'AcessoNegado' });
              }
            }
          })
          .catch((error) => {
            localStorage.clear();
            next({ name: 'Login' })
          });
        }
      } else if((to.name === 'Login' && usuariologado) || (to.path == '/' && usuariologado)){
        switch (usuarioHelper.USUARIO_LOGADO().perfil.id) {
          case 8:
            next({ name: 'GridSolicitacaoCotacao' });
          break;
          default:
            next({ name: 'ListagemSolicitacoes' });
       }
      } else if (to.path == '/') {
        next({ name: 'Questionario' });
      }
      if (!acessoNegado) {
        next();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/controller.js